import ShDividerLine from '@/components/Helpers/ShDividerLine';
import LayoutForConfigurationAndPreview from './Common/LayoutForConfigurationAndPreview';
import WidgetBehaviorConfiguration from './WidgetBehaviorConfiguration';
import WidgetButtonConfiguration from './WidgetButtonConfiguration';
import WidgetButtonPreview from './WidgetButtonPreview';
import WidgetFooterConfiguration from './WidgetFooterConfiguration';
import WidgetFooterPreview from './WidgetFooterPreview';
import WidgetScreensConfiguration from './WidgetScreensConfiguration';
import WidgetScreensPreview from './WidgetScreensPreview';

// @vue/component
export default {
  name: 'WidgetStyleAndConfiguration',

  components: {
    ShDividerLine,
    LayoutForConfigurationAndPreview,
    WidgetBehaviorConfiguration,
    WidgetButtonConfiguration,
    WidgetButtonPreview,
    WidgetFooterConfiguration,
    WidgetFooterPreview,
    WidgetScreensConfiguration,
    WidgetScreensPreview,
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    widget: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      activeTab: 'widgetBehavior',
    };
  },

  computed: {
    accessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'];
    },
  },
};
